import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CleintService } from '../../../shared/services/client.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: 'app-social-media-link',
  templateUrl: './social-media-link.component.html',
  styleUrls: ['./social-media-link.component.scss']
})
export class SocialMediaLinkComponent implements OnInit {
  isLoading=false;
  lang;
  linkList =[];
  constructor(
    private cleintService:CleintService,
    private translate: TranslateService
  ) { 

  }

  ngOnInit(): void {
    this.getsocial_media();
 
  }


  async getsocial_media() {

    this.isLoading=true;
    this.cleintService.getsocial_media().subscribe({
      next: (response: any) => {
        this.isLoading=false;
        this.linkList = response?.data;

      },
      error: (error) => {
        this.isLoading=false;
      }
    }
    );

  }



}
